import { render, staticRenderFns } from "./AddNotesModal.vue?vue&type=template&id=71492fbd&scoped=true&"
import script from "./AddNotesModal.vue?vue&type=script&lang=js&"
export * from "./AddNotesModal.vue?vue&type=script&lang=js&"
import style0 from "./AddNotesModal.vue?vue&type=style&index=0&id=71492fbd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71492fbd",
  null
  
)

export default component.exports